import { configureStore } from "@reduxjs/toolkit";
import { user, snacks, relationals, themeColor, openDrawer } from "./slices/index.js";

export default configureStore({
  reducer: { user, snacks, relationals, themeColor, openDrawer },
});
